import { StorageItems } from '../../shared/constants/app';

/**
 * Registers a global listener for Vite's `vite:preloadError` event.
 *
 * After a deployment, hashed chunk filenames change and the old files are
 * removed from the server. Users who still have the previous bundle open
 * will request chunks that no longer exist, causing dynamic imports to fail.
 * This handler auto-reloads the page so the browser fetches the latest build.
 *
 * A sessionStorage cooldown prevents infinite reload loops when the failure
 * is caused by network issues rather than a stale deploy.
 */
export const initStaleChunkReloader = () => {
  const RELOAD_COOLDOWN_MS = 10_000;
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();

    const lastReload = sessionStorage.getItem(
      StorageItems.VITE_PRELOAD_ERROR_LAST_RELOAD,
    );
    const now = Date.now();

    const shouldReload =
      !lastReload || now - Number(lastReload) > RELOAD_COOLDOWN_MS;

    if (shouldReload) {
      sessionStorage.setItem(
        StorageItems.VITE_PRELOAD_ERROR_LAST_RELOAD,
        String(now),
      );

      window.location.reload();
    }
  });
};
